meedy.controller('meedy.changePasswordController', ['$scope', '$rootScope', '$state', '$stateParams', '$timeout', 'meedy.objectHelper', 'applicationModel', 'meedy.authModel', 'meedy.userModel', '$translate',
    function ($scope, $rootScope, $state, $stateParams, $timeout, objectHelper, applicationModel, authModel, userModel, $translate) {

        function setData() {
            $scope.passwordData = new LoginMeedyVO();
            $scope.uuid = $stateParams.uuid;

            $scope.authenticationError = false;

            $scope.forms = {
                passwordForm: null
            };

            $scope.passwordIsToWeak = false;
            $scope.differentPasswords = false;
        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on('$destroy', function (event) {
                applicationModel.viewReady = false;
            });

            $scope.$on(Event.MEEDY.USER.VALIDATE_USER_PARTNER_TOKEN.SUCCESS, function (event, data) {
                $scope.user = data.user;
                $scope.descriptionData = {
                    partnerType : $translate.instant('T.MEEDY.ENUM.USER_PARTNER_TYPE.' + $scope.user.partnerType),
                    medicalPost : data.medicalPost.name
                };
            });

            $scope.$on(Event.MEEDY.USER.VALIDATE_USER_PARTNER_TOKEN.ERROR, function (event, error) {
                $scope.authenticationError = true;
            });

            $scope.$on(Event.MEEDY.USER.CONFIRM_CREATION.SUCCESS, function (event, error) {
                $state.go(Constant.STATE.PRE.MEEDY.LOGIN);
            });
        }

        function setActions() {

            $scope.onChange = function() {
                if($scope.forms.passwordForm && $scope.passwordData.newPassword && $scope.passwordData.password
                    && ($scope.passwordData.newPassword.length > 7 && $scope.passwordData.password.length > 7
                    && $scope.passwordData.newPassword === $scope.passwordData.password)) {

                    var power = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g;

                    var _lowerLetters = /[a-z]+/.test($scope.passwordData.password);
                    var _upperLetters = /[A-Z]+/.test($scope.passwordData.password);
                    var _numbers = /[0-9]+/.test($scope.passwordData.password);
                    var _symbols = _regex.test($scope.passwordData.password);

                    if(_lowerLetters) {
                        power++;
                    }if(_upperLetters) {
                        power++;
                    }if(_numbers) {
                        power++;
                    }if(_symbols) {
                        power++;
                    }

                    if(power < 4) {
                        $scope.passwordIsToWeak = true;
                    } else {
                        $scope.passwordIsToWeak = false;
                    }
                    $scope.differentPasswords = false;
                } else if($scope.passwordData.newPassword !== $scope.passwordData.password) {
                    $scope.differentPasswords = true;
                }
            };

            $scope.changePassword = function() {
                $scope.forms.passwordForm.$setSubmitted();

                var power = 0;
                var _regex = /[$-/:-?{-~!"^_`\[\]]/g;

                var _lowerLetters = /[a-z]+/.test($scope.passwordData.password);
                var _upperLetters = /[A-Z]+/.test($scope.passwordData.password);
                var _numbers = /[0-9]+/.test($scope.passwordData.password);
                var _symbols = _regex.test($scope.passwordData.password);

                if(_lowerLetters) {
                    power++;
                }if(_upperLetters) {
                    power++;
                }if(_numbers) {
                    power++;
                }if(_symbols) {
                    power++;
                }

                $scope.differentPasswords = $scope.passwordData.newPassword !== $scope.passwordData.password;

                if(power < 4 || $scope.differentPasswords) {
                    $scope.passwordIsToWeak = true;
                    return;
                } else {
                    $scope.passwordIsToWeak = false;
                }

                if ($scope.forms.passwordForm.$valid) {
                    userModel.confirmCreation($scope.passwordData.newPassword, $scope.uuid);
                }
            };

            $scope.goToLogin = function() {
                $state.go(Constant.STATE.PRE.MEEDY.LOGIN);
            };

        }

        function configureInterface() {
        }

        function initialize() {
            $timeout(function(){
                applicationModel.viewReady = true;
                userModel.validateUserPartnerToken($scope.uuid);
            });
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
